// removed by extract-text-webpack-plugin
module.exports = {"common-checkbox":"common-checkbox"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/CheckBox/index.less
// module id = 748
// module chunks = 418